<template>
	<label
		class="checkbox"
		:class="[
			errors && 'error',
			required && 'required-input',
		]"
	>
		<input
			type="checkbox"
			:checked="checked"
			:value="value"
			@change="onChange"
		/>
		<span
			class="checkbox__custom-input"
			:class="[
				errors && 'error',
			]"
		></span>
		<span class="checkbox__label label"><slot></slot></span>
		<span
			class="checkbox__errors input-errors"
			v-if="errors"
		>
			<span
				class="input-errors__item"
				v-for="(err, i) in errors"
				:key="i"
			>{{ err }}</span>
		</span>
	</label>
</template>

<script>
export default {
	props: {
		value: {},
		checked: {
			type: Boolean,
		},
		required: {
			type: Boolean,
		},
		name: {
			type: String,
		},
		errors: {
			type: [
				Array,
				Object,
			],
		},
	},

	methods: {
		onChange(e) {
			this.$emit('change', e.target.checked)
			this.$emit('input', e.target.checked)
		},
	},
}
</script>

<style lang="scss">
@import '@/sass/_variables';

.checkbox {
	display: inline-flex;
	flex-wrap: wrap;
	position: relative;
	cursor: pointer;

	&::before {
		top: -2px !important;
		left: 18px !important;
	}

	input {
		position: absolute;
		margin: 0;
		padding: 0;
		width: 16px !important;
		height: 16px !important;
		left: 0;
		top: 2px;
		opacity: 0;
	}

	&__custom-input {
		flex-shrink: 0;
		position: relative;
		top: 2px;
		width: 16px;
		min-width: 16px;
		height: 16px;
		border: 2px solid rgba($primary, 0.25);
		background-color: transparent;
		margin-right: 10px;
		border-radius: 3px;
		cursor: pointer;
		transition: 0.2s;
		box-sizing: border-box;

		&::before {
			content: '\e900';
			font-family: 'globalcode-icons' !important;
			display: block;
			position: absolute;
			width: 100%;
			height: 100%;
			left: -2px;
			top: 0;
			line-height: 12px;
			font-size: 18px;
			text-align: center;
			color: #230a51;
			transition: 0.2s;
			opacity: 0;
		}

		input:hover + &,
		input:focus + & {
			border-color: $primary;
			box-shadow: 0 0 8px rgba(#000, 0.1);
		}

		input:checked + & {
			background-color: $primary;

			&::before {
				opacity: 1;
			}
		}
	}

	&__label {
		flex: 1 0 0;
	}

	&__errors {
		width: 100%;
	}
}
</style>
